var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
    for (var name in all) __defProp(target, name, {
      get: all[name],
      enumerable: !0
    });
  },
  __copyProps = (to, from, except, desc) => {
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
  };
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: !0
}), mod);
var wrapStyleTags_exports = {};
__export(wrapStyleTags_exports, {
  wrapStyleTags: () => wrapStyleTags
});
module.exports = __toCommonJS(wrapStyleTags_exports);
var import_helpers = require("@tamagui/helpers"),
  import_jsx_runtime = require("react/jsx-runtime");
function wrapStyleTags(styles, content) {
  return process.env.TAMAGUI_REACT_19 && styles.length ? /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [content, styles.map(styleObject => {
      const identifier = styleObject[import_helpers.StyleObjectIdentifier];
      return /* @__PURE__ */(0, import_jsx_runtime.jsx)("style", {
        href: `t_${identifier}`,
        precedence: "default",
        children: styleObject[import_helpers.StyleObjectRules].join(`
`)
      }, identifier);
    })]
  }) : content;
}